import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useLinkedToDependent(): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const linkedToDependent = (athleteId: string): Promise<AxiosResponse<{}>> => {
    return client.put(`athletes/${athleteId}/linked-to-dependent/`);
  };

  return useMutation(linkedToDependent, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['connectedAthletes'],
      });
    },
  });
}
